<template>
    <div class="py-10">
        <div class="uppercase font-bold mb-4">{{header}}</div>

        <div v-if="!loading" class="grid grid-cols-2 lg:grid-cols-4 gap-5">
            <div v-for="sermon in randSermons">
                <RouterLink :to="`/sermons/${sermon.id}`" class="h-40 section-image bg-slate-200">
                    <img :src="sermon.data.cover_image" class="w-full" :alt="sermon.data.title + ' image'" loading="lazy">
                    <div class="hidden md:block">
                        <div class="text-lg font-bold">{{ sermon.data.title }}</div>
                        <div class="text-sm text-[#f97316]"><span class="font-bold">Upload date:</span> {{ new
                            Date(sermon.data.date_created).toDateString() }}</div>
                    </div>
                </RouterLink>
            </div>
        </div>
        <div v-else>
            <Loader />
        </div>
    </div>
</template>

<script setup>
import firebaseFuncs from '../../utils/firebase'
import { onMounted, ref } from 'vue';
import Loader from '../Loader.vue';

let props = defineProps(['header'])
let { getRandomSermons } = firebaseFuncs

const randSermons = ref([])
const loading = ref(true)

onMounted(async () => {
    randSermons.value = await getRandomSermons(4)
    loading.value = false
})
</script>

<style scoped>
.section-image{
    background-image: url('../../assets/images/placeholder.jpg');
    background-size: contain;
    background-position: center;
}
</style>